export default "__VITE_ASSET__0b3e00e1__"